import React from "react";
import "./EducationComponent.css";

const EducationComponent = () => {
  return (
    <>
      <div className="containerr">
        <div className="entry">
          <div className="indicator">
            <span></span>
          </div>
          <p className="content">
            <span>Electronics & Communication Engineering (B.Tech)</span>
            Jalaiguri Government Enginnering College
            <br />
            <b>DGPA : </b>9.03
          </p>
          <div className="timee">2020-2024</div>
        </div>
        <div className="entry">
          <div className="indicator">
            <span></span>
          </div>
          <p className="content">
            <span>Higher Secondary</span>
            Purba Barasat Adarsha Bidyapeeth
            <br />
            <b>Percentage : </b> 88.40%
          </p>
          <div className="timee">2017-2019</div>
        </div>
        <div className="entry">
          <div className="indicator">
            <span></span>
          </div>
          <p className="content">
            <span>Secondary</span>
            Purba Barasat Adarsha Bidyapeeth
            <br />
            <b>Percentage : </b> 91.57%
          </p>
          <div className="timee">2016-2017</div>
        </div>
      </div>
    </>
  );
};

export default EducationComponent;
